import { DocumentTextIcon } from '@heroicons/react/20/solid';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

// import { getAllArticles } from '@/libs/blog/articles';

export default function RelatedBlogs({ articles, article }) {
  const relatedBlogs = articles
    .filter(
      (item) => item.slug !== article.slug && item.tagLink === article.tagLink,
    )
    .slice(0, 3);
  return (
    <div className="flex flex-col gap-5 mt-4 lg:mt-8">
      <h4 className="text-sm tracking-tight text-zinc-500">Related Posts</h4>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {relatedBlogs.map((blog, index) => (
          <div
            key={index}
            className="flex h-full flex-col justify-between rounded-md"
          >
            <Link
              href={`/blog/${blog.slug}`}
              className="flex flex-col gap-2"
              title={blog.title}
            >
              <div className="relative h-64 w-full overflow-hidden rounded-md border border-zinc-300 bg-zinc-100">
                <Image
                  alt={blog.title}
                  loading="lazy"
                  decoding="async"
                  src={blog.thumbnail}
                  width={329}
                  height={256}
                  style={{
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    color: 'transparent',
                  }}
                  className="rounded-md object-cover transition-all duration-200 ease-in-out h-full w-full absolute"
                />
              </div>
              <h2 className="text-lg font-semibold leading-6 transition-colors duration-200 ease-in-out">
                {blog.title}
              </h2>
              <p className="text-zinc-500">{blog.description}</p>
            </Link>
            <div className="mt-2 flex select-none flex-row items-center gap-2">
              <DocumentTextIcon className="h-4 w-4 text-zinc-500" />
              <p>{`${blog.minsToRead} min read`}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
